import { render, staticRenderFns } from "./helpModal.vue?vue&type=template&id=71c8c3e8&scoped=true"
import script from "./helpModal.vue?vue&type=script&lang=js"
export * from "./helpModal.vue?vue&type=script&lang=js"
import style0 from "./helpModal.vue?vue&type=style&index=0&id=71c8c3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8c3e8",
  null
  
)

export default component.exports